import { T } from '@/i18n/LocaleProvider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { MONO_FONT } from '@/theme';

// Card con kicker mono + título (h4) + body. Patrón compartido por
// grids de capacidades/diferenciadores (Tecnología, Planes, Playbook).
// El contenedor (grid + stagger) lo pone cada vista.
export default function KickerCard({ kicker, title, body }) {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 1,
        p: { xs: '24px', md: '28px' },
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <Typography
        sx={{
          fontFamily: MONO_FONT,
          fontSize: '10.5px',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: 'text.accent',
          fontWeight: 600,
        }}
      >
        <T>{kicker}</T>
      </Typography>
      <Typography variant="h4" component="h3">
        <T>{title}</T>
      </Typography>
      <Typography
        sx={{ fontSize: '14px', lineHeight: 1.55, color: 'grey.600' }}
      >
        <T>{body}</T>
      </Typography>
    </Box>
  );
}
